import { track } from "../track";

export const trackSubscriptionCancelFail = () =>
  track({ event: "subscription_cancel_fail" });
